function relatedProductSliderAddToCartInit() {
  const atcButtons = document.querySelectorAll(
    ".cart-section__related-items-slider .evm-add-to-cart-popup-inner"
  );

  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  atcButtons.forEach(function (button) {
    if (button.classList.contains("related-atc-enabled")) {
      return;
    }
    button.classList.add("related-atc-enabled");

    const id = button.getAttribute("data-vid");

    const formData = {
      items: [
        {
          id: parseInt(id, 10),
          quantity: 1,
        },
      ],
    };

    button.addEventListener("click", async (event) => {
      event.preventDefault();

      // Add to cart via AJAX
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      // Fetch updated cart data
      await fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // update item count in drawer header
          const newCount = cart.item_count;
          const drawerCount = document.querySelector(".drawer__item-count");
          const countBubble = document.querySelector(".cart-count-bubble");
          const countBubbleSpan = document.querySelectorAll(
            ".cart-count-bubble span"
          );
          const emptyHeader = document.querySelector(
            ".cart-drawer__empty-content"
          );
          const emptyCollections = document.querySelector(
            ".cart__empty-collections"
          );

          // Hide empty collections section if new item added
          if (emptyCollections && newCount > 0) {
            emptyCollections.style.display = "none";
          }

          // Hide empty cart header if new item added
          if (emptyHeader && newCount > 0) {
            emptyHeader.style.display = "none";
          }

          // Update count bubble
          if (countBubble && newCount > 0) {
            countBubble.classList.remove("ws-hide-count");

            countBubbleSpan.forEach((span) => {
              span.innerHTML = newCount;
            });
          }

          // Update drawer count
          if (drawerCount && newCount) {
            drawerCount.innerHTML = newCount;
          }
        });

      // Fetch updated cart drawer HTML
      await fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          // parse the response HTML
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          // replace existing cart items with updated items
          const targetElement = document.querySelector("cart-drawer-items");
          const sourceElement = html.querySelector("cart-drawer-items");

          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
            relatedProductSliderAddToCartInit(); // re-initialize related items after updating cart items
          }

          // Update totals
          const targetTotals = document.querySelector(
            ".cart-drawer__footer .totals"
          );
          const sourceTotals = html.querySelector(
            ".cart-drawer__footer .totals"
          );

          if (targetTotals && sourceTotals) {
            targetTotals.replaceWith(sourceTotals);
          }

          // Update checkout buttons
          const cartCtas = document.querySelector(".cart__ctas");
          const sourceCtas = html.querySelector(".cart__ctas");

          if (cartCtas && sourceCtas) {
            cartCtas.replaceWith(sourceCtas);
          }

          // open cart drawer
          cart.classList.add("active");
        })
        .catch((error) => {
          console.error("Error updating cart drawer:", error);
        });
    });
  });
}

relatedProductSliderAddToCartInit();

function debounce(func, delay) {
  let timer; // Holds the timeout ID

  return function (...args) {
    const context = this; // Preserve the 'this' context

    clearTimeout(timer); // Clear any existing timer

    timer = setTimeout(() => {
      func.apply(context, args); // Execute the original function after the delay
    }, delay);
  };
}

// console.log("this is a text");
/*
document.addEventListener('click', function(event) {
    let freeProductId = 44628455719161; // Free product ID
    let validProducts = ["metro-jetlamp-with-safety-cage", "metro", "metro-jetlamp-with-bistro"];

    function updateFreeProduct() {
      fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
             // console.log(cart, 'cart')
              let freeProductInCart = cart.items.some(item => item.id == freeProductId);
              // console.log(freeProductInCart, 'freeProductInCart')
              let cartTotal = cart.total_price / 100;
              let cartSubtotal = cart.items.reduce((total, item) => {
                  return item.id == freeProductId ? total : total + item.final_line_price;
              }, 0) / 100;
            let validCollectionTotal = cart.items.reduce((total, item) => {
              // console.log(item, 'item')
                if (
                    item.id !== freeProductId  &&
                    validProducts.includes(item.handle)
                ) {
                    return total + item.final_line_price;
                }
                return total;
            }, 0) / 100;

           let validCollectionFound = validCollectionTotal > 0;
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                cartTotal = cart.total_price / 100;
                // console.log(cart, 'cart');
                cartSubtotal = cart.items.reduce((total, item) => {
                    return item.id == freeProductId ? total : total + item.final_line_price;
                }, 0) / 100;
               freeProductInCart = cart.items.some(item => item.id == freeProductId);
               validCollectionTotal = cart.items.reduce((total, item) => {
                if (
                    item.id !== freeProductId &&
                    validProducts.includes(item.handle)
                ) {
                  // console.log('newtotal1', total + item.final_line_price)
                    return total + item.final_line_price;
                }
                 // console.log('newtotal', total)
                return total;
            }, 0) / 100;
                validCollectionFound = validCollectionTotal > 0;

              if ( validCollectionFound) {
                  if (!freeProductInCart) {
                    setTimeout(function(){
                      // $('.free_product_wrapper').trigger('click');
                    var shop_url = window.origin;

                  Data = {
                    quantity: 1,
                    id: 44628455719161,
                  };

                $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: Data,
                  success: function () {
                      $.ajax({
                        type: "GET",
                        url: "/cart?view=cart-drawer",
                        success: function (data) {
                          var cartitem = $(data).find(".drawer__cart-items-wrapper").html();
                          // console.log(cartitem, 'cartitem')

                          $(".drawer__cart-items-wrapper").html(cartitem);
                          // console.log($(".drawer__cart-items-wrapper").html(cartitem), '75478684')

                          setTimeout(function () {
                            // console.log('it is working')
                             $('.header__icon--cart').trigger('click');
                            $(".cart-count-number").text(cart.item_count + 1);
                          console.log(cart, 'cart', cart.item_count + 1, typeof cart.item_count + 1)
                          }, 500);
                        },
                        error: function (data) {
                          console.log(data);
                        },
                      });
                    },
                    error: function (err) {
                      console.log(err);
                    },
                   });

                      // console.log('it worked')
                    },100)
                  } else {
                    console.log('Free product already in cart, skipping addition');
                  }
              }
              else if (validCollectionTotal   < 0 && freeProductInCart) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: { id: freeProductId, quantity: 0 },
                    success: function() {
                      // setTimeout(()=>{
                      //   location.reload();
                      // },500)
                    }
                  });
              }
           })
        })
        .catch(error => console.error('Error fetching cart:', error));
      }
     setTimeout(function(){
        updateFreeProduct();
     },1000)
       updateFreeProduct();
  });
*/
